import { usePermission as usePermissionCore } from '@obtainly/hooks';
import { useAtom, permissionsAtom } from 'src/core/store';
export function usePermission() {
    var permissions = useAtom(permissionsAtom)[0];
    return usePermissionCore(permissions);
}
